import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../../components/card/card";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import ModalChangeCategory from "./modal/changeCategory";
import {
  assetCategory,
  customerType,
  partCategory,
  vendorType,
  workOrderCategory,
  serviceCategory,
  meterMeasurementUnit,
  issueTrackingType,
} from "../../../../api";
import { PermissionChecker } from "../../../../components/PermissionChecker";

function CategoryList({ type }) {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });

  const [datas, setDatas] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);

  async function getData() {
    try {
      setLoading(true);
      let res;
      if (type == "Work Order") {
        res = await workOrderCategory.list(query);
      }
      if (type == "Asset") {
        res = await assetCategory.list(query);
      }
      if (type == "Part") {
        res = await partCategory.list(query);
      }
      if (type == "Service") {
        res = await serviceCategory.list(query);
      }

      if (type == "Vendor") {
        res = await vendorType.list(query);
      }

      if (type == "Customer") {
        res = await customerType.list(query);
      }

      if (type == "Meter Measurement Unit") {
        res = await meterMeasurementUnit.list(query);
      }
      if (type == "Issue Tracking Type") {
        res = await issueTrackingType.list(query);
      }

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setDatas(data.results);
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getData();
  }, [type, query.page, query.take]);

  function addData(value) {
    setOpenDetail(true);
  }
  function editData(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteData() {
    try {
      let res;
      if (type == "Work Order") {
        res = await workOrderCategory.delete(deleteRow.id);
      }
      if (type == "Asset") {
        res = await assetCategory.delete(deleteRow.id);
      }
      if (type == "Part") {
        res = await partCategory.delete(deleteRow.id);
      }
      if (type == "Service") {
        res = await serviceCategory.delete(deleteRow.id);
      }
      if (type == "Vendor") {
        res = await vendorType.delete(deleteRow.id);
      }

      if (type == "Customer") {
        res = await customerType.delete(deleteRow.id);
      }

      if (type == "Meter Measurement Unit") {
        res = await meterMeasurementUnit.delete(deleteRow.id);
      }

      if (type == "Issue Tracking Type") {
        res = await issueTrackingType.delete(deleteRow.id);
      }

      if (res.ok) {
        toast.success("This data has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        await getData();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <PermissionChecker permissions={["edit category"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  editData(row);
                }}
                className="btn btn-sm btn-outline-theme mx-1"
              >
                <i className="fa fa-edit"></i>
              </button>
            </PermissionChecker>
            <PermissionChecker
              permissions={["delete category"]}
              hideIfNotAllowed
            >
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];
  async function onSubmit({ name }) {
    let data = {
      name: name.trim(),
    };

    if (!data.name) {
      toast.error("Please input a valid name!");
      return;
    }
    if (!selectedRow) {
      let response;

      if (type == "Work Order") {
        response = await workOrderCategory.create(data);
      }
      if (type == "Asset") {
        response = await assetCategory.create(data);
      }
      if (type == "Part") {
        response = await partCategory.create(data);
      }
      if (type == "Service") {
        response = await serviceCategory.create(data);
      }
      if (type == "Vendor") {
        response = await vendorType.create(data);
      }

      if (type == "Customer") {
        response = await customerType.create(data);
      }

      if (type == "Meter Measurement Unit") {
        response = await meterMeasurementUnit.create(data);
      }

      if (type == "Issue Tracking Type") {
        response = await issueTrackingType.create(data);
      }

      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success(name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          await getData();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      let response;

      if (type == "Work Order") {
        response = await workOrderCategory.update(selectedRow.id, data);
      }
      if (type == "Asset") {
        response = await assetCategory.update(selectedRow.id, data);
      }
      if (type == "Part") {
        response = await partCategory.update(selectedRow.id, data);
      }
      if (type == "Service") {
        response = await serviceCategory.update(selectedRow.id, data);
      }
      if (type == "Vendor") {
        response = await vendorType.update(selectedRow.id, data);
      }

      if (type == "Customer") {
        response = await customerType.update(selectedRow.id, data);
      }
      if (type == "Meter Measurement Unit") {
        response = await meterMeasurementUnit.update(selectedRow.id, data);
      }
      if (type == "Issue Tracking Type") {
        response = await issueTrackingType.update(selectedRow.id, data);
      }
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Successfully updated data");
          setSelectedRow(null);
          setOpenDetail(false);
          await getData();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <ModalChangeCategory
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      ></ModalChangeCategory>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteData}
      >
        <div>Are you sure you want to delete this?</div>
      </ConfirmationDlg>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <PermissionChecker
                permissions={["create category"]}
                hideIfNotAllowed
              >
                <button
                  onClick={addData}
                  className="btn btn-outline-theme w-100"
                >
                  Add Category / Type <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardBody>
              <DataTable
                progressPending={loading}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={datas}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default CategoryList;
